import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import { ReadCrmAuthInfo, UpdateCrmAuthInfo } from '@tinct/core-api-models';
import { ApiError, tinctApi } from '../../api';

export type UpdateCrmIntegrationAuthInfoParams = UpdateCrmAuthInfo & {
  integrationId: string;
  organizationId: string;
};

export const updateCrmIntegrationAuthInfo = async ({
  integrationId,
  organizationId: _organizationId,
  ...params
}: UpdateCrmIntegrationAuthInfoParams): Promise<ReadCrmAuthInfo> => {
  return await tinctApi.crmIntegrations.updateCrmIntegrationAuthInfo(
    integrationId,
    params
  );
};

export const useUpdateCrmIntegrationAuthInfo = (
  options?: Omit<
    UseMutationOptions<
      ReadCrmAuthInfo,
      ApiError,
      UpdateCrmIntegrationAuthInfoParams
    >,
    'mutationFn'
  >
) => {
  const { onSuccess, ...restOptions } = options || {};

  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateCrmIntegrationAuthInfo,
    onSuccess: (...args) => {
      const { integrationId, organizationId } = args[1];
      queryClient.invalidateQueries({
        queryKey: ['crm-integration-auth-info', integrationId],
      });
      queryClient.invalidateQueries({
        queryKey: ['crm-integrations'],
      });
      queryClient.invalidateQueries({
        queryKey: ['organization', organizationId],
      });
      onSuccess?.(...args);
    },
    ...restOptions,
  });
};
